












import { PropType } from 'vue';
import moment from 'moment';
import { mapActions } from 'vuex';

import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import snackbar from '@/mixins/snackbar';
import QuoteLayoutMixin from '@/mixins/quotes/QuoteLayoutMixin';

import { Quote } from '@/models/quote';
import { createPdf, setErrorFromAxiosError } from '@/utils/helpers';

export default mixins(auth, snackbar, QuoteLayoutMixin).extend({
  name: 'QuoteGenerateOrderReviewListItem',

  props: {
    quote: { type: Object as PropType<Quote>, required: true }
  },

  methods: {
    ...mapActions({
      exportQuoteOrderReview: 'quote/exportQuoteOrderReview'
    }),

    generateOrderReview() {
      this.createSnack({
        color: 'success darken-1',
        type: 'success',
        right: true,
        useBtn: false,
        msg: 'Generating order review',
        btnText: 'Ok',
        timeout: 2000
      }).then(() => {
        this.exportQuoteOrderReview({
          quoteId: this.quote.number,
          language: 'en'
        })
          .then((data: Blob) => {
            createPdf(
              data,
              `${this.quote.number}-quote-order-review-${moment(
                new Date()
              ).format('YYYY-MM-DD-HH-mm-ss')}`
            );
          })
          .catch(error => {
            const systemError = setErrorFromAxiosError(error);

            this.createSnack({
              color: 'error',
              type: 'error',
              right: true,
              useBtn: false,
              msg: `Failed to generate order review: ${systemError.detail ||
                systemError.message}`,
              btnText: 'Ok',
              timeout: 6000
            });
          });
      });
    }
  }
});
